module.exports = __webpack_public_path__ + "static/img/baby_g.cf29c543.png";